import { BREADCRUMB_SELECT } from '../actionTypes/index';
const initialState={
    slice:false
}
 const SliceBreadcrumb=(state=initialState,action)=>{
    switch(action.type){
        case BREADCRUMB_SELECT:
            return {
                ...state,
                slice:action.payload
            }
            default:
                return state;
    }
}

export default SliceBreadcrumb;